import script from "./ProductPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPage.vue?vue&type=script&setup=true&lang=js"

import "./ProductPage.vue?vue&type=style&index=0&id=4da49c04&scoped=true&lang=css"

import exportComponent from "/workspaces/e-commerce-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da49c04"]])

export default __exports__